export default __webpack_public_path__ + "7e60bfa7ba239415439f16f3533266d0.png";